module.exports = "/_next/static/images/358004c2e37243502571f276a69cd69d-rewards-smiles@0.75x.png.webp";